import { getTranslations } from "next-intl/server";
const CategoryHeader = async ({
  categoryName,
  totalCount
}) => {
  const t = await getTranslations("Common");
  return <div className="absolute inset-0 z-10 flex flex-col items-center justify-center pt-10 text-white" data-sentry-component="CategoryHeader" data-sentry-source-file="CategoryHeader.jsx">
      {categoryName && <h1 className="font-heading rtl:font-arabic pt-4 text-center text-3xl font-semibold md:text-6xl">
          {categoryName}
        </h1>}
      {totalCount && <p className="leading-0 py-3 text-center text-sm font-medium md:text-lg">{`${t("Showing")} ${totalCount} ${t("Products")}`}</p>}
    </div>;
};
export default CategoryHeader;